import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { useTileStyles } from './styles'

const Tile = React.forwardRef(({ title, text, isDisabled, ...props }, ref) => {
  const classes = useTileStyles()
  return (
    <div
      ref={ref}
      className={classnames(classes.tileWrapper, {
        disabled: isDisabled
      })}
      {...props}
    >
      <header className={classes.tileTitle}>{title}</header>
      <p className={classes.tileText}>{text}</p>
    </div>
  )
})

Tile.propTypes = {
  isDisabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  text: PropTypes.string
}

export default Tile
